import React from "react";
import { useSelector } from "react-redux";
import { ACTIVE, USER_ADMIN_TABS } from "constants/userAdmin";
import { USER_ADMIN_LICENSE, USER_ADMIN_USERS } from "constants/routes";
import { Link } from "react-router-dom";

const UserAdminTabs = () => {
  const active = useSelector((state) => state.userAdmin.activeTab);

  return (
    <div className="user_admin__tabs" data-testid={USER_ADMIN_TABS}>
      <Link to={USER_ADMIN_USERS} className={`${active === 0 ? ACTIVE : ""}`}>
        <div className="user_admin__tabs__users">
          <span>Users</span>
        </div>
      </Link>
      <Link to={USER_ADMIN_LICENSE} className={`${active === 1 ? ACTIVE : ""}`}>
        <div className="user_admin__tabs__license">
          <span>License</span>
        </div>
      </Link>
    </div>
  );
};

export default UserAdminTabs;
